import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, LogOut, Settings } from "lucide-react";
import { clearAuth, getUser } from "@/lib/auth";

import { LOGO_URL } from "@/constants/records";

export default function Header({ showBack = true, title = null }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome   = location.pathname === "/";
  const user     = getUser();

  const logout = () => { clearAuth(); navigate("/login"); };

  return (
    <header className="sticky top-0 z-40 border-b border-line bg-bg/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          {showBack && !isHome && (
            <Link to="/" data-testid="back-home-btn"
              className="-ml-1 flex h-10 w-10 items-center justify-center rounded-full text-ink-soft transition-colors hover:bg-muted hover:text-ink"
              aria-label="Tornar">
              <ArrowLeft size={20} />
            </Link>
          )}
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <img src={LOGO_URL} alt="Sublims" className="h-9 w-auto" />
            <div className="hidden sm:block leading-tight">
              <div className="font-display text-lg font-bold text-ink">Sublims</div>
              <div className="label-eyebrow !text-[0.6rem]">Registres APPCC</div>
            </div>
          </Link>
        </div>
        <div className="flex items-center gap-2">
          {title && (
            <div className="font-display text-sm font-semibold text-ink-soft sm:text-base mr-2">{title}</div>
          )}
          {user && (
            <>
              <span className="hidden sm:block text-sm font-semibold text-ink-soft">
                {user.username.charAt(0) + user.username.slice(1).toLowerCase()}
              </span>
              {user.rol === "admin" && (
                <Link to="/admin"
                  className="flex h-9 w-9 items-center justify-center rounded-full text-ink-soft transition-colors hover:bg-muted hover:text-ink"
                  aria-label="Administracio">
                  <Settings size={18} />
                </Link>
              )}
              <button onClick={logout}
                className="flex h-9 w-9 items-center justify-center rounded-full text-ink-soft transition-colors hover:bg-muted hover:text-ember"
                aria-label="Tancar sessio">
                <LogOut size={18} />
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
